(function () {
	'use strict';

	angular.module('qbePortal').directive('qbAutoSubmitForm', function ($timeout) {
		return {
			restrict: 'A',
			link: function ($scope, $el, $attr) {
				$timeout(function () {
					angular.element($el).submit();
				});
			}
		}
	});
})();
